<template>
  <ImageSlider
    class="-mx-2 md:mx-0 md:rounded-lg"
    :class="heightClasses"
    :images="images"
    cover-full
    @slide-change="onSlideChange"
  >
    <template #container-overlay>
      <WebccSearch
        v-if="showSearchBar"
        class="h-fit p-8 sm:p-12"
        :class="hasImages ? 'bg-transparent' : 'bg-thm rounded-lg'"
        :locale="$i18n.locale"
        :show-background="hasImages"
        :search-query-params="searchQueryParams"
        :date-range-flex-search-classes="dateRangeFlexSearchClasses"
      >
        <template #extraLine>
          <slot name="extraLine" />
        </template>
      </WebccSearch>
    </template>
  </ImageSlider>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    block: Block<SearchbarBlockContent>
    searchQueryParams?: string[]
    showSearchBar?: boolean
  }>(),
  {
    searchQueryParams: undefined,
    showSearchBar: true,
  },
)

const { extraLine } = useSlots()
const tracking = useTracking()
const tracked = ref<number[]>([])

const images = computed(() =>
  props.block.content.images.map((img, key) => ({
    id: `img-${key}`,
    src: img.asset,
    alt: img.alt,
    title: img.alt,
    loaded: true,
  })),
)

const hasImages = computed(() => !!images.value.length)

const heightClasses = computed(() =>
  hasImages.value ? 'h-[400px] md:h-[410px]' : 'h-[280px] md:h-[150px]',
)

const dateRangeFlexSearchClasses = computed(() =>
  [
    'left-0 md:left-auto md:right-0',
    hasImages.value
      ? 'md:min-w-[67.25%] lg:min-w-[63.5%] md:mr-12'
      : 'md:min-w-[72.75%] lg:min-w-[68.5%]',
    extraLine ? 'md:top-[11rem]' : 'md:top-[9rem]',
  ].join(' '),
)

function onSlideChange(index: number) {
  tracking.handlers?.detail.galleryNavigation()

  if (tracked.value.includes(index)) return

  tracking.handlers?.teaser.heroSliderElementImpression({
    id: '',
    creative: `${index + 1} ${images.value[index].alt}`,
    position: `1/${index + 1}`,
  })
  tracked.value.push(index)
}

onMounted(() => {
  if (!images.value.length) return

  tracking.handlers?.teaser.heroSliderElementImpression({
    id: '',
    creative: `1 ${images.value[0].alt}`,
    position: '1/1',
  })
  tracked.value.push(0)
})
</script>
